
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/register",
      function () {
        return require("private-next-pages/company/register/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/register"])
      });
    }
  